import { FC, useState } from 'react';

import APIConfiguration from '@savgroup-front-common/configuration/api';
import { MyAccountIcon } from '@savgroup-front-common/core/protons/IconsNewDesign';
import { ICONS_TYPE } from '@savgroup-front-common/types';

import { $Img } from './PaymentMethodImage.styles';

interface PaymentMethodImageProps {
  paymentMethod?: string;
}

export const PaymentMethodImage: FC<PaymentMethodImageProps> = ({
  paymentMethod,
}) => {
  const [shouldRenderFallback, setShouldRenderFallback] = useState(false);

  const imageUrl = `${APIConfiguration.catalogCDN}miscellaneous/paymentMethodPartner/${paymentMethod}.png`;

  if (!paymentMethod) {
    return null;
  }

  return (
    <>
      {!shouldRenderFallback && (
        <$Img
          src={imageUrl}
          onError={() => {
            setShouldRenderFallback(true);
          }}
          alt={paymentMethod}
        />
      )}

      {shouldRenderFallback && (
        <MyAccountIcon icon={ICONS_TYPE.CREDIT_CARD_ICON} />
      )}
    </>
  );
};
